<div id="priceContent" class="d-flex flex-column h-100">
  <div id="profileText" class="profile-text" *ngIf="presentPage === profile_page">
    <div id="profileNameTitle" class="profile-name-title">{{profileNameValue}}</div>
    <h2 class="profile-name-text">{{profileDataSet?.profileName}}</h2>
  </div>
  <div id="livePreview" class="al_live_preview" [ngClass]="tabIndex === 2 || tabIndex === 3 || tabIndex === 4 ? 'preview_padding' : ''">
    <iposcen-content-live-preview
      *ngIf="(presentPage === profile_page && (tabIndex === 0 || tabIndex === 1)) || (presentPage === assets_page && tabIndex === 1)"
      [sidenav]="pageType" [pricePresentPage]="presentPage"></iposcen-content-live-preview>
    <!-- Live preview - temporarly image -->

    <iposcen-live-preview *ngIf="tabIndex === 2 || tabIndex === 3 || tabIndex === 4  "></iposcen-live-preview>
    <!-- Layout of preview -->
    <div id="layout" class="preview_layout ht" *ngIf="showPreviewLayout && (tabIndex === 2 || tabIndex === 3 || tabIndex === 4)">
      <div  id="LCG1" class="card">
        <img src="{{LCGlayout === 1 ?  'assets/images/prev_layout_selected_1.svg': 'assets/images/prev_layout_1.svg'}}"
          alt="layout 1" (click)="setLayout(1)" class="cursor-pointer" />
      </div>
      <div id="LCG2" class="card">
        <img src="{{LCGlayout === 2 ?  'assets/images/prev_layout_selected_2.svg': 'assets/images/prev_layout_2.svg'}}"
          alt="layout 2" (click)="setLayout(2)" class="cursor-pointer" />
      </div>
      <div id="LCG3" class="card">
        <img src="{{LCGlayout === 3 ?  'assets/images/prev_layout_selected_3.svg': 'assets/images/prev_layout_3.svg'}}"
          alt="layout 3" (click)="setLayout(3)" class="cursor-pointer" />
      </div>
    </div>
  </div>
  <ul *ngIf="(tabIndex === 1 || tabIndex === 2 || tabIndex === 3 || tabIndex === 4)" class="nav nav-tabs"
    role="tablist">
    <li class="nav-item">
      <a class="nav-link gtmAssetLibraryPriceContentTitle" data-toggle="tab" [ngClass]="{'active': tabIndex === 1}"
        (click)="navigate()"><span placement="top" container='body'
          ngbTooltip="{{editCheck?showPriceContentName + details:newPriceContentTitle}}">
          {{editCheck? tabTrimString(showPriceContentName) : tabTrimString(newPriceContentTitle) }}</span></a>
    </li>
    <li class="nav-item" *ngIf="pages?.page1">
      <a class="nav-link gtmAssetLibraryPriceContentPage1" data-toggle="tab" [ngClass]="{'active': tabIndex === 2}"
	         (click)="clickable?setIndex(2):false"><span i18n="@@global.tab-nav.page1">PAGE 1</span></a>

        <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
      <!-- <a class="nav-link gtmAssetLibraryPriceContentPage1" data-toggle="tab" [ngClass]="{'active': tabIndex === 2}"
        (click)="clickable?setIndex(2):false">
        <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page1">PAGE 1</span>&nbsp;</div>
          <div class="delete_page" *ngIf="pagelen > 1" (click)="clickable?openPopupPrice(delete,0):false"></div>
        </div>
      </a> -->
    </li>
    <li class="nav-item" *ngIf="pages?.page2">
      <a class="nav-link gtmAssetLibraryPriceContentPage2" data-toggle="tab" [ngClass]="{'active': tabIndex === 3}"
	         (click)="clickable?setIndex(3):false"><span i18n="@@global.tab-nav.page2">PAGE 2</span></a>

      <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
      <!-- <a class="nav-link gtmAssetLibraryPriceContentPage2" data-toggle="tab" [ngClass]="{'active': tabIndex === 3}"
        (click)="clickable?setIndex(3):false">
        <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page2">PAGE 2</span>&nbsp;</div>
          <div class="delete_page" (click)="clickable?openPopupPrice(delete,1):false"></div>
        </div>
      </a> -->
    </li>
    <li class="nav-item" *ngIf="pages?.page3">
      <a class="nav-link gtmAssetLibraryPriceContentPage3" data-toggle="tab" [ngClass]="{'active': tabIndex === 4}"
         (click)="clickable?setIndex(4):false"><span i18n="@@global.tab-nav.page3">PAGE 3</span></a>

      <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
      <!-- <a class="nav-link gtmAssetLibraryPriceContentPage3" data-toggle="tab" [ngClass]="{'active': tabIndex === 4}"
        (click)="clickable?setIndex(4):false">
        <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page3">PAGE 3</span>&nbsp;</div>
          <div class="delete_page" (click)="clickable?openPopupPrice(delete,2):false"></div>
        </div>
      </a> -->
    </li>
    <li class="nav-item" *ngIf="clickable && !checkPages()">
      <a class="nav-link gtmAssetLibraryPriceContentAddPage" data-toggle="tab" (click)="addPage()">
        <img src="assets/images/add_black_square_outline.svg" alt="add pages" />
      </a>
    </li>
    <li class="nav-item exit_preview" *ngIf="pages?.page1">
      <a class="nav-link gtmAssetLibraryPriceContentCancel" (click)="cancel()">
        <img src="assets/images/exit_icon.svg" alt="exit without changes" />
      </a>
    </li>
  </ul>

  <!-- Main section -->
  <section *ngIf="tabIndex === 0" class="main_section al_storepromo" [ngClass]="!isdevicePrice ? 'device-section':''">
    <div id="priceContent" class="d-flex flex-column h-100">
      <!-- Price Content Group Tab -->
      <div id="priceTab" *ngIf="tabIndex === 0" id="priceContentGroups">
        <div id="priceData" *ngIf='isdevicePrice' class="main_section_headers"
          [ngClass]="(presentPage === profile_page)?'profile_section_headers':''">
          <div class="d-flex align-items-center">
            <img *ngIf="presentPage === assets_page" class="price_header" alt="header icon" />
            <span i18n="@@price-content.header-title.price-content">PRICE CONTENT</span>
          </div>
          <span class="data_action" *ngIf="presentPage === profile_page && displayPriceContentGroups?.length">
            <button type="button" id="uploadprice"
              class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryPriceContentAddNewPriceContent"
              (click)="addNewPriceContent()">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 3.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H8V4C8 3.86739 8.05268 3.74021 8.14645 3.64645C8.24021 3.55268 8.36739 3.5 8.5 3.5Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8 8C8 7.86739 8.05268 7.74021 8.14645 7.64645C8.24021 7.55268 8.36739 7.5 8.5 7.5H12.5C12.6326 7.5 12.7598 7.55268 12.8536 7.64645C12.9473 7.74021 13 7.86739 13 8C13 8.13261 12.9473 8.25979 12.8536 8.35355C12.7598 8.44732 12.6326 8.5 12.5 8.5H9V12C9 12.1326 8.94732 12.2598 8.85355 12.3536C8.75979 12.4473 8.63261 12.5 8.5 12.5C8.36739 12.5 8.24021 12.4473 8.14645 12.3536C8.05268 12.2598 8 12.1326 8 12V8Z"
                    fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 15C10.3565 15 12.137 14.2625 13.4497 12.9497C14.7625 11.637 15.5 9.85652 15.5 8C15.5 6.14348 14.7625 4.36301 13.4497 3.05025C12.137 1.7375 10.3565 1 8.5 1C6.64348 1 4.86301 1.7375 3.55025 3.05025C2.2375 4.36301 1.5 6.14348 1.5 8C1.5 9.85652 2.2375 11.637 3.55025 12.9497C4.86301 14.2625 6.64348 15 8.5 15ZM8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16Z" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="16" height="16" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
              <span i18n="@@price-content.new-price-content-group">New Price Content Group</span>
            </button>
          </span>
        </div>
        <!-- Data header with info like no. of content groups, action buttons and filters -->
        <div id="priceDataHeader" class="data_header" *ngIf="((presentPage!== undefined) && (presentPage === assets_page || profile_page))"
          [ngClass]="(displayPriceContentGroups?.length > 0)?'':'display-block'">
          <ng-container *ngIf="presentPage === assets_page">
            <span *ngIf="displayPriceContentGroups?.length > 0">
              <span *ngIf="displayPriceContentGroups && displayPriceContentGroups?.length == 1"
                id="dataTitle">{{displayPriceContentGroups?.length}}&nbsp;{{priceContentGroupLabel}}</span>
              <span *ngIf="displayPriceContentGroups && displayPriceContentGroups?.length > 1"
                id="dataTitle">{{displayPriceContentGroups?.length}}&nbsp;<span
                  i18n="@@price-content.price-content-groups.count.name">Price
                  Content Groups</span></span>
              <span *ngIf="displayPriceContentGroups?.length > 1">
                <span i18n="@@price-content.group-tab.sort-by">Sort by</span>:&nbsp;
                <div  id="priceDropDown" ngbDropdown class="d-inline-block">
                  <button ngbDropdownToggle class="btn btn-primary btn-sm" id="sortDropDown">{{sortValue}}
                  </button>
                  <div id="priceDropDownMenu" ngbDropdownMenu aria-labelledby="sortDropDown">
                    <button ngbDropdownItem *ngIf="sortValue!=createdDateLabel"
                      (click)="sortByDate()">{{createdDateLabel}}</button>
                    <button ngbDropdownItem *ngIf="sortValue!=groupNameLabel"
                      (click)="sortByName()">{{groupNameLabel}}</button>
                  </div>
                </div>
              </span>
            </span>
            <span *ngIf="displayPriceContentGroups?.length === 0"
              i18n="@@price-content.group-tab.price-in-ipos-footer">Add a Price Content Group of up to 3 pages to your
              device price in the IPOS footer.</span>
          </ng-container>
          <ng-container *ngIf="presentPage === profile_page">
            <div id="priceContentGroups">
              <div id="priceContentGroupsLength" *ngIf="displayPriceContentGroups?.length > 0">
                <strong><span i18n="@@price-content.price-content-groups.add-to-package">Added to
                    Package</span>:</strong>
                {{ selctedContGrpsForProfile.contentGrps?.length || '0'}}
                <span i18n="@@segments.content-groups-label">Content Groups</span>
              </div>
              <div id="priceShowOnDevice" *ngIf="displayPriceContentGroups?.length > 0">
                <strong><span i18n="@@price-content.price-content-groups.show-on-device">Show on Device</span>:</strong>
                {{ selctedContGrpsForProfile.showOnDevice ? '1': '0'}}
                <span i18n="@@segments.content-groups-label">Content Groups</span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="presentPage === profile_page && !displayPriceContentGroups?.length">
            <span i18n="@@price-content.group-tab.price-info-for-shoppers">Add Price Content to display the pricing
              information of a device to shoppers.</span><br />
            <strong><span i18n="@@price-content.group-tab.no-price-content-group">No Price Content Group has been
                created.</span></strong>
          </ng-container>
          <span class="data_action"
            *ngIf="presentPage === assets_page || (presentPage === profile_page && !displayPriceContentGroups?.length)">
            <button type="button" id="uploadprice"
              class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryPriceContentAddNewPriceContent"
              (click)="addNewPriceContent()">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 3.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H8V4C8 3.86739 8.05268 3.74021 8.14645 3.64645C8.24021 3.55268 8.36739 3.5 8.5 3.5Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8 8C8 7.86739 8.05268 7.74021 8.14645 7.64645C8.24021 7.55268 8.36739 7.5 8.5 7.5H12.5C12.6326 7.5 12.7598 7.55268 12.8536 7.64645C12.9473 7.74021 13 7.86739 13 8C13 8.13261 12.9473 8.25979 12.8536 8.35355C12.7598 8.44732 12.6326 8.5 12.5 8.5H9V12C9 12.1326 8.94732 12.2598 8.85355 12.3536C8.75979 12.4473 8.63261 12.5 8.5 12.5C8.36739 12.5 8.24021 12.4473 8.14645 12.3536C8.05268 12.2598 8 12.1326 8 12V8Z"
                    fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 15C10.3565 15 12.137 14.2625 13.4497 12.9497C14.7625 11.637 15.5 9.85652 15.5 8C15.5 6.14348 14.7625 4.36301 13.4497 3.05025C12.137 1.7375 10.3565 1 8.5 1C6.64348 1 4.86301 1.7375 3.55025 3.05025C2.2375 4.36301 1.5 6.14348 1.5 8C1.5 9.85652 2.2375 11.637 3.55025 12.9497C4.86301 14.2625 6.64348 15 8.5 15ZM8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16Z" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="16" height="16" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
              <span i18n="@@price-content.new-price-content-group">New Price Content Group</span>
            </button>
          </span>
        </div>
        <ng-container *ngIf="presentPage === profile_page && displayPriceContentGroups?.length">
          <div id="iposFooter" class="mt-3 mb-3">
            <span i18n="@@price-content.group-tab.price-in-ipos-footer">Add a Price Content Group of up to 3 pages to
              your device price in the IPOS footer.</span><br />
            <strong><span i18n="@@price-content.group-tab.3-price-content-group">You may add up to 3 Price Content
                Groups.</span></strong>
          </div>
        </ng-container>
        <!-- Data Content -->
        <div id="dataContents" class="data_content segments_only" *ngIf="displayPriceContentGroups?.length > 0"
          [ngClass]="presentPage === profile_page?'acc_table_view':''">
          <div id="showOnDeviceSelect" class="show_on_device_select" *ngIf="presentPage === profile_page">
            <div class="small_text border-right shown-on-device-label"><span
                i18n="@@segments.shown-on-device-label">Show on
                Device</span></div>
            <div><span i18n="@@segments.content-groups-label">Content Groups</span></div>
          </div>
          <div class="accordion" id="logoContentAccordian">
            <!-- Group 1 -->
            <!-- Commenting this line as part of UAT-377-->
            <!-- <div class="card" *ngIf='!isdevicePrice'>
            <div class = "card-header small_text" >
              <input class="mt-3 mr-2" [checked]='!idFromPriceContent' (click)='sendPriceData("None")' name='devicePrice' type="radio">
              <div class="d-flex card-header-content">
                <div class="title_left title_left_device">
                  <div class="d-flex">
                    <div class="title">
                      <span i18n="@@device-price-content.title.none-label">None</span>
                    </div> 
                  </div> 
                </div>
              </div>
            </div>
          </div> -->
          <div id="priceContentCard" class="card" *ngIf="presentPage === profile_page">
            <div id="priceContentCardBottom" class="card card_bottom">
              <div id="segmentOne" class="card-header none_text">
                <div id="priceAccCheck" class="acc_check">
                  <div id="priceRadio" class="form-check">
                    <input type="radio" name="cpLCGSelect" class="form-check-input" value="isPriceContentNone"
                      [checked]="isPriceContentNone" (change)="removeShowonDevice()">
                  </div>
                </div>
                <div id="priceContentHeader" class="card-header-content">
                  <div id="PriceDatalib" class="d-flex">
                    <div id="libNone" class="select_none">
                      <span i18n="@@hero-tile.asset-library.none">None</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="card" id="PriceContentGroupsCard"
              *ngFor="let priceContentGroup of displayPriceContentGroups | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
              <div class="card-header small_text" id="segmentOne">
                <input class="mt-3 mr-2" [checked]='priceContentGroup.id === idFromPriceContent'
                  (click)='sendPriceData(priceContentGroup)' name='devicePrice' type="radio" *ngIf='!isdevicePrice'>
                <div id="priceAccCheck2" class="acc_check" *ngIf="presentPage === profile_page">
                  <div id="priceContentRadio" class="form-check" [ngbPopover]="(!priceContentGroup?.addToPackage) ? showonDeviceDisabled:''"
                    [placement]="changePlacement == true ? 'left' : 'right'" triggers="mouseenter:mouseleave">
                    <input type="radio" name="cpLCGSelect" class="form-check-input"
                      [value]="priceContentGroup?.showOnDevice" [checked]="priceContentGroup?.showOnDevice"
                      (change)="addToProfile($event,priceContentGroup.index,'radio')"
                      [disabled]="!priceContentGroup.addToPackage" />
                  </div>
                </div>
                <div id="priceCardHeaderContent" class="card-header-content">
                  <div id="priceTitle" class="title_left" [ngClass]="{'title_left_device' : !isdevicePrice, 'title_left_device_price': presentPage === deviceDashboardPage}">
                    <div id="priceData2" class="d-flex">
                      <div id="publishedName" class="title">
                        <span>{{priceContentGroup?.configurations?.publishedName}} &nbsp;&nbsp;</span>
                      </div>
                    </div>
                    <div class="d-flex">
                    <div *ngIf="(priceContentGroup.isContentExpires)" id="contentExpire" class="content-expire"><img class="contents-info-icon" alt="info_icon"><span>{{globalconst.CONT_GRP_EXPIRED_TEXT}}</span></div>
                    <div class="d-flex" id="editBtn"
                      *ngIf="presentPage === assets_page && ((!priceContentGroup.islocked && isStoreUser) || !isStoreUser)">
                      <button type="button" placement="bottom" ngbTooltip={{tooltipEdit}}
                        (click)="editPrice(priceContentGroup?.id)" class="btn gtmEditSegment">
                        <img alt="Edit" />
                      </button>
                      <button type="button" placement="bottom" ngbTooltip={{tooltipDelete}}
                        (click)="openDeleteModal(priceContentGroup?.id)" class="btn gtmDeleteSegment">
                        <img alt="Delete" />
                      </button>
                      <iposcen-delete-popup #deleteModal [contentName]="priceCGToDeleteName"
                        [buttonName]="tooltipContentGroup" (delete)="deletePriceCG(priceCGToDelete)">
                      </iposcen-delete-popup>
                      <button type="button" *ngIf="isRetailerUser || isRegionalHQ" class="btn gtmSendPrice gtmSendBtn"
                        placement="bottom" ngbTooltip={{tooltipSendToStore}} container="body"
                        (click)="openSendPriceContentToAccountModal(priceContentGroup?.id)">
                        <img alt="Send" />
                      </button>
                    </div>
                  </div>
                  </div>
                  <div id="otherData" class="other_data" *ngIf='isdevicePrice'>
                    <div id="assetIDCopy">
                      <iposcen-assetid-copy [assetID]="priceContentGroup?.id" *ngIf="presentPage === assets_page">
                      </iposcen-assetid-copy>
                      <div id="subtitleGrp" class="subtitle_group">
                        <span class="subtitle" i18n="@@price-content.group-tab.created-by">Created By:
                          {{priceContentGroup?.createdByUser}}</span>
                          <span class="subtitle"><span i18n="@@logo-content.logo-content-groups.last-edited-by">Last
                            Edited By</span>
                          {{priceContentGroup?.createdByUser}}:
                          {{priceContentGroup?.updateTime | dateFormat: "changeToLocalTimeZone"}}</span>
                        <span class="subtitle" *ngIf="presentPage === assets_page && userRole !== 'nonConnectedUser'"
                          i18n="@@price-content.group-tab.pushed">Pushed to all devices:
                          {{priceContentGroup?.ispushedToDevice ? YES : NO}}</span>
                        <span *ngIf="priceContentGroup?.configurations?.internalName" class="subtitle"><span>{{internalName}}:</span>
                          {{priceContentGroup?.configurations?.internalName}}
                        </span>
                      </div>
                      <div id="addToProfile" class="form-check mt-3" *ngIf="presentPage === profile_page"
                        [ngbPopover]="(selctedContGrpsForProfile.contentGrps?.length === 3 && !priceContentGroup.addToPackage) ? addToPackageDisabled:''"
                        placement="top-left" triggers="mouseenter:mouseleave">
                        <input class="form-check-input" type="checkbox" [value]="priceContentGroup?.addToPackage"
                          [checked]="priceContentGroup?.addToPackage"
                          (change)="addToProfile($event,priceContentGroup.index,'check')"
                          [id]="'addToPackOne'+priceContentGroup.index"
                          [disabled]="selctedContGrpsForProfile.contentGrps?.length === 3 && !priceContentGroup.addToPackage" />
                        <label class="form-check-label" [for]="'addToPackOne'+priceContentGroup.index">
                          <span i18n="@@price-content.group-tab.add-to-package">Add to Package</span>
                        </label>
                      </div>
                    </div>
                    <div class="d-flex" id="gtmlock"
                      *ngIf="presentPage === assets_page && priceContentGroup.islocked && isStoreUser">
                      <div id="gtmlockIcon" class="gtmlockIcon lock-icon">
                        <img alt="content locked" /> 
                        <span class="pl-1 pt-1">{{lockContentText}}</span>
                      </div>
                    </div>
                    <div id="customControl" class="custom-control custom-switch"
                      *ngIf="(presentPage === assets_page) && (userRole === retailHqUser || userRole === regionalHqUser)">
                      <input type="checkbox" class="custom-control-input" [id]="'lockContent'+priceContentGroup?.id"
                        [checked]="priceContentGroup?.islocked" [value]="priceContentGroup?.islocked"
                        (click)=changeLockContentStatus(priceContentGroup?.id,$event,priceContentGroup) />
                      <label class="custom-control-label" [for]="'lockContent'+priceContentGroup?.id">
                        <span i18n="@@price-content.group-tab.lock-content">Lock Content</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div id="collapseLink" class="collapse_link collapsed collapse-button {{priceContentGroup?.id}}" type="button"
                  (click)="getDetailsOfPriceCG(priceContentGroup?.id)"
                  [ngClass]="priceContentGroup.isExpanded ? 'transform-180' : ''">
                  <svg class="accordian_expanded" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                  </svg>
                </div>
              </div>
              <div id="collapseThree" class="collapse priceContentPreview" #collapse="ngbCollapse"
                [(ngbCollapse)]="!priceContentGroup.isExpanded" aria-labelledby="logoCGThree"
                data-parent="#logoContentAccordian">
                <div id="priceCardBody" class="card-body" [ngClass]="presentPage === profile_page?'':presentPage === assets_page?'card-body-asset':'card-body-device'">
                  <!-- IIT2-4655-->
                  <div id="tabNav" class="clearfix">
                    <ul  class="nav nav-tabs float-left" role="tablist" *ngIf="priceContentGroup.configurations?.contentGroupPages?.length">
                      <li class="nav-item">
                          <a class="nav-link gtmAssetLibraryLogoContentTitle" data-toggle="tab" [ngClass]="{'active': priceContentGroup.previewTabIndex === 0}" (click)="previewNavigate(0, priceContentGroup.id)">
                              <span placement="top" container='body' i18n="@@hero-tile.asset-library.main-content">Main content</span>
                          </a>
                      </li>
                      <li class="nav-item">
                          <a class="nav-link gtmAssetLibraryLogoContentTitle" data-toggle="tab" [ngClass]="{'active': priceContentGroup.previewTabIndex === 1}" (click)="previewNavigate(1, priceContentGroup.id)">
                              <span placement="top" container='body' i18n="@@hero-tile.asset-library.page-content">Page contents</span>
                          </a>
                      </li>
                    </ul>
                    <div id="duplicatetPriceContent" *ngIf="presentPage === assets_page || presentPage === profile_page" class="duplicate-and-edit-span float-right">
                      <button (click)="duplicateAndEditPriceContent(priceContentGroup.id)" type="button"
                        class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryPriceContentDuplicateAndEdit">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3 2H11C11.5304 2 12.0391 2.21071 12.4142 2.58579C12.7893 2.96086 13 3.46957 13 4V14C13 14.5304 12.7893 15.0391 12.4142 15.4142C12.0391 15.7893 11.5304 16 11 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V4C1 3.46957 1.21071 2.96086 1.58579 2.58579C1.96086 2.21071 2.46957 2 3 2V2ZM3 3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H11C11.2652 15 11.5196 14.8946 11.7071 14.7071C11.8946 14.5196 12 14.2652 12 14V4C12 3.73478 11.8946 3.48043 11.7071 3.29289C11.5196 3.10536 11.2652 3 11 3H3Z"
                            fill="white" />
                          <path
                            d="M5 0H13C13.5304 0 14.0391 0.210714 14.4142 0.585786C14.7893 0.960859 15 1.46957 15 2V12C15 12.5304 14.7893 13.0391 14.4142 13.4142C14.0391 13.7893 13.5304 14 13 14V13C13.2652 13 13.5196 12.8946 13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12V2C14 1.73478 13.8946 1.48043 13.7071 1.29289C13.5196 1.10536 13.2652 1 13 1H5C4.73478 1 4.48043 1.10536 4.29289 1.29289C4.10536 1.48043 4 1.73478 4 2H3C3 1.46957 3.21071 0.960859 3.58579 0.585786C3.96086 0.210714 4.46957 0 5 0V0Z"
                            fill="white" />
                        </svg>
                        <span i18n="@@price-content.group-tab.duplicate-edit">Duplicate and Edit</span>
                      </button>
                    </div>
                  </div>
                  <div id="storeTab" class="tab-content">
                    <div *ngIf="priceContentGroup.previewTabIndex === 0" id="storeLogos" class="tab-pane pl-0 view_herotile_details" [ngClass]="{'active': priceContentGroup.previewTabIndex === 0}">
                      <div id="publishDateTimeSec" class="clearfix">
                        <div id="publishDateTime" class="float-left column col-md-4">
                          <div id="publishTime" class="pb-4">
                            <span i18n="@@price-content.group-tab.publish-date-time" class="font-weight-bold">Publishing Date and
                            Time</span>
                            <div id="ConfigPublishTime">{{priceContentGroup?. configurations?.publishTime | dateFormat: "24hrP"}}</div>
                          </div>
                          <div>
                            <span i18n="@@price-content.group-tab.expiration-date-time" class="font-weight-bold">Expiration Date
                              and Time</span>
                            <div>{{priceContentGroup?. configurations?.expireTime | dateFormat: "24hrP"}}</div>
                          </div>
                        </div>
                        <div id="FormFactor" class="float-left col-md-8" *ngIf="priceContentGroup?.configurations?.formFactor">
                          <div id="FFNameBreak" class="name-break">
                            <table class="table-borderless form-factors-main-div mt-0" aria-describedby="formFactors">
                              <tr>
                                <th scope="col" class="pb-1"><span i18n="@@banner-carousel.content-group-applies-to">Content Group
                                    Applies
                                    To</span>: </th>
                              </tr>
                              <tr>
                                <td><strong><span>{{globalconst.DEVICE_TYPES}}</span>: </strong>
                                  {{ priceContentGroup?.configurations?.formFactor?.devices.length ? priceContentGroup?.configurations?.formFactor?.devices : globalconst.ALL}}
                                </td>
                              </tr>
                              <tr>
                                <td><strong><span>{{globalconst.MANUFACTURERS}}</span>:</strong>
                                  {{ priceContentGroup?.configurations?.formFactor?.manufacturer.length ?
                                  priceContentGroup?.configurations?.formFactor?.manufacturer : globalconst.ALL}}
                                </td>
                              </tr>
                              <tr>
                                <td><strong><span>{{globalconst.PROCESSORS}}</span>: </strong>
                                  {{ priceContentGroup?.configurations?.formFactor?.processors.length ? priceContentGroup?.configurations?.formFactor?.processors :
                                  globalconst.ALL}}
                                </td>
                              </tr>
                              <tr>
                                <td><strong><span>{{globalconst.GENERATIONS}}</span>:</strong>
                                  {{ priceContentGroup?.configurations?.formFactor?.generations.length ? priceContentGroup?.configurations?.formFactor?.generations :
                                  globalconst.ALL}}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="priceContentGroup.previewTabIndex === 1" id="storeLogos" class="tab-pane pl-0" [ngClass]="{'active': priceContentGroup.previewTabIndex === 1}">
                      <div id="newwinDetailPage" class="detailpage__content newwin_detail_page">
                        <div id="priceContentMainContainer" class="main-container">
                          <div id="priceContenData" class="d-flex ">
                            <ng-container *ngFor="let page of priceContentGroup.configurations.contentGroupPages"> 
                                <iposcen-mini-live-preview [data]="loadMiniPreview(priceContentGroup?.id,page)">
                                </iposcen-mini-live-preview>
                            </ng-container>
                          </div>  
                        </div>
                      </div>
                    </div>  
                  </div>
                  <!-- IIT2-4655 end-->
                </div>
              </div>
            </div>
            <iposcen-send-to-segment-account #sendToAccountModal [sendName]="sendNameToStore"
              [sendButtonName]="sendButtonText" (selectedStoreData)="getSelectedStoreData($event)"
              [sendToStoreSuccess]="isSendToStore" (clearAllData)="isSendToStore=false">
            </iposcen-send-to-segment-account>

          </div>
        </div>
        <!-- Data Footer - Pagination -->
        <div id="priceContentFooter" class="data_footer">
          <nav aria-label="price content pagination"
            *ngIf="displayPriceContentGroups && displayPriceContentGroups?.length">
            <ngb-pagination [collectionSize]="displayPriceContentGroups.length" [(page)]="page" [pageSize]="pageSize"
              [rotate]="true" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"></ngb-pagination>
          </nav>
        </div>
      </div>
      <div id="skipBtnWrapper" class="button-wrapper justify-content-end" *ngIf="presentPage === profile_page">
        <button type="button" class="btn btn-outline-primary gtmAssetLibraryPriceContentSkip"
          (click)="sendToProfile('skip')">
          <span i18n="@@price-content.group-tab.skip">Skip</span>
        </button>
        <button type="button" class="btn btn-primary gtmAssetLibraryPriceContentSaveAndProceed"
          (click)="sendToProfile('send')" [disabled]="displayPriceContentGroups?.length === 0">
          <span class="gtmAssetLibraryPriceContentSaveAndProceed" i18n="@@logo-content.logo-content-groups.save-and-continue"> Save and
            Continue</span>
        </button>
      </div>
    </div>
  </section>

  <!-- Create New Price section -->
  <section *ngIf="tabIndex === 1 || tabIndex === 2 || tabIndex === 3 || tabIndex === 4"
    class="main_section al_newpromo">
    <ng-container>
      <div id="tab1" *ngIf="tabIndex === 1">
        <iposcen-create-price-content [isNavigated]="isNavigated" [presentpage]="presentPage" (goBacktoPriceContent)="setCreatedGrpID($event)">
        </iposcen-create-price-content>
      </div>
      <div  id="tab2" *ngIf="tabIndex === 2">
        <iposcen-page #page1 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=1
          [mediaObjs]="mediaObjects" (goBacktoLogoContent)="refreshPriceContentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
      <div  id="tab3" *ngIf="tabIndex === 3">
        <iposcen-page #page2 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=2
          [mediaObjs]="mediaObjects" (goBacktoLogoContent)="refreshPriceContentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
      <div  id="tab4" *ngIf="tabIndex === 4">
        <iposcen-page #page3 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=3
          [mediaObjs]="mediaObjects" (goBacktoLogoContent)="refreshPriceContentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
    </ng-container>
     
    <div id="priceActBtn" class="button-wrapper priceActBtn mb-4 mr-4" *ngIf="tabIndex === 2 || tabIndex === 3|| tabIndex === 4">
      <button type="button" class="btn btn-outline-primary left_icon_btn gtmAddPagePrice" (click)="addPage()"
        *ngIf="!isPage3Created">
        <img src="assets/images/plus_square_outline.svg" alt="add page" />
        <span i18n="@@price-content.group-tab.added-package">Add Page</span>
      </button>
      <button type="button" class="btn btn-primary gtmSavePriceContGrp"
        (click)="pageError.get(1)||pageError.get(2)||pageError.get(3)?openPopup(errorPopup):updatePriceContent()">
        {{buttonName}}
      </button>
      <iposcen-showon-device #showModal (show)="showOnDevice()" (closePopup)="closeShowOnDevice()">
      </iposcen-showon-device>
      <iposcen-apply-changes-to-devices #applyModal (apply)="applyToDevice(true)" (closePopup)="applyToDevice(false)">
      </iposcen-apply-changes-to-devices>
    </div>
  </section>
</div>
<!-- //popup page delete  -->
<ng-template #delete let-modal>
  <div id="confrmPopUp" class="card confirmPopup">
    <div id="modalHeader" class="modal-header">
      <div id="modalCloseIcon" (click)="modal.close()" class="close-icon">
        <img src="../../../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="modalBody" class="modal-body popup-body">
      <div id="modalBodyTitle">
        <h2 class="mt-3">
          <span i18n="@@create-partner-content.delete-modal.delete-page?">Delete Page?</span>
        </h2>
        <div id="modalBodyText" class="card-desc">
          <span i18n="@@create-partner-content.delete-modal.remove-permanently">This content will be removed permanently.</span>
        </div>
      </div>
    </div>
    <div id="modalFooter" class="modal-footer card-footer">
      <button type="button" (click)="modal.close()" class="btn btn-outline-primary btn-cancel">
        <span i18n="@@create-partner-content.delete-modal.cancel">Cancel</span>
      </button>
      <button type="button" class="btn btn-primary btn-confirm" (click)="modal.close();deletePages(whichPageDelete)">
        <span i18n="@@create-partner-content.delete-modal.delete-page">Delete Page</span>
      </button>
    </div>
  </div>
</ng-template>
<ng-template #errorPopup let-modal>
  <div id="errorPopup" class="card confirmPopup">
    <div id="errorPopupHeader" class="modal-header">
      <div id="errorPopupClose" (click)="modal.close()" class="close-icon">
        <img src="../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="errorPopupModalBody" class="modal-body popup-body">
      <div id="pageErr">
        <div id="priceCardDesc" class="card-desc">
          <span *ngIf='pageError.get(1) && !pageError.get(2) && !pageError.get(3)'>{{errorMessageText}}</span>
          <span *ngIf='pageError.get(1) && pageError.get(2)  && !pageError.get(3)'>{{errorMessageText1}}</span>
          <span *ngIf='pageError.get(1) && pageError.get(3)  && !pageError.get(2)'>{{errorMessageText2}}</span>
          <span *ngIf='pageError.get(2) && !pageError.get(3) && !pageError.get(1)'>{{errorMessageText3}}</span>
          <span *ngIf='pageError.get(2) && pageError.get(3)  && !pageError.get(1)'>{{errorMessageText4}}</span>
          <span *ngIf='pageError.get(3) && !pageError.get(1) && !pageError.get(2)'>{{errorMessageText5}}</span>
          <span *ngIf='pageError.get(3) && pageError.get(1) && pageError.get(2)'>{{errorMessageText6}}</span>
        </div>
      </div>
    </div>
    <div id="ModalFooter" class="modal-footer card-footer">
      <button type="button" (click)="modal.close();goToErrorPage()" class="btn btn-primary btn-confirm">
        <span>{{buttonLable}}</span>
      </button>
    </div>
  </div>
</ng-template>